// Customer portals linked from the nav and the assistant.
//
// Two naming samples are built for review (REACT_APP_PORTAL_NAMING):
//   function (default) - "Asset Portal" / "Shipment Portal": named after what the customer does there
//   product            - "TrueLog Portal" / "Shipthis Portal": named after the software
export const INVENTORY_PORTAL_URL = 'https://inventory.truelog.com.sg/auth/login';
// TODO: replace with the real Shipthis customer-portal login once it is confirmed
export const SHIPTHIS_PORTAL_URL = process.env.REACT_APP_SHIPTHIS_URL || '#shipthis-portal';

export interface Portal {
  label: string;
  hint: string;
  href: string;
}

const NAMING = process.env.REACT_APP_PORTAL_NAMING === 'product' ? 'product' : 'function';

export const PORTALS: Portal[] =
  NAMING === 'product'
    ? [
        { label: 'TrueLog Portal', hint: 'Inventory system: assets, tickets and device tracking', href: INVENTORY_PORTAL_URL },
        { label: 'Shipthis Portal', hint: 'Freight quotes, bookings and shipment tracking', href: SHIPTHIS_PORTAL_URL },
      ]
    : [
        { label: 'Asset Portal', hint: 'Assets, tickets and device tracking', href: INVENTORY_PORTAL_URL },
        { label: 'Shipment Portal', hint: 'Freight quotes, bookings and shipment tracking', href: SHIPTHIS_PORTAL_URL },
      ];
